<script>
import {mutation as columns} from '../../tables'
import { serviceColors, transactionServices } from "../../config/transaction"

const types = {
  in: '#237804',
  out: '#a8071a'
};

export default {
  props: {
    path: {
      type: String,
      required: true
    },
    backend: {
      type: Boolean,
      default: false
    },
    excludes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    serviceColors,
    transactionServices,
    exportUri() {
      let params = _.merge(this.filters, {
        timestamp: (new Date).getTime(),
        export: 1,
      })

      return this.routeUri(this.path, {}, true) + '?' + this.$qs.stringify(params)
    },
    downloadCondition() {
      return this.filters.date.length === 0 || this.filters.service.length === 0
    },
    pagination() {
      return { pageSize: this.pageSize, current: this.items.current_page, total: this.items.total, showSizeChanger: true }
    },
    pageSize() {
      return parseInt(this.items.per_page)
    },
  },
  data() {
    return {
      columns,
      filtering: false,
      downloadWarningVisibility: false,
      items: {},
      types,
      expand: false,
      loading: false,
      filters: {
        page: 1,
        q: '',
        date: [],
        service: [],
        products: []
      }
    }
  },
  created() {
    this.items = this.getDefaultPagination()
    this.filters = _.merge(this.filters, this.$hyperion.request)
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri(this.path, {}, true), {
        params: this.filters
      })
        .then((response) => this.items = response.data)
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.loading = false)
    },
    tableChanged(pagination) {
      this.filters.page = pagination.current
      this.filters.per_page = pagination.pageSize
      this.pushState(this.filters)
      this.getItems()
    },
    handleDownload() {
      this.downloadWarningVisibility = false

      window.open(this.exportUri, '_blank')
    },
    handleWarningVisibility(visible) {
      if (!visible) {
        this.downloadWarningVisibility = false
        return
      }

      if (!this.downloadCondition) {
        this.handleDownload()
      } else {
        this.downloadWarningVisibility = true
      }
    },
    filtered(filters) {
      Object.assign(this.filters, filters)
      this.filtering = false
      this.getItems()
    }
  }
}
</script>

<template>
  <div>
    <a-card type="inner" size="small">
      <div slot="extra">
        <a-popconfirm @confirm="handleDownload" okText="Continue">
          <template slot="title">
            Are you sure you want to continue?
            <br>
            Tips: please consider selecting date and/or service filter
          </template>
          <a-button @click="handleWarningVisibility" class="ml-2" size="small" type="primary" icon="cloud-download" />
        </a-popconfirm>

        <a-button size="small" icon="filter" title="Filter Form" @click="() => filtering = true" />
      </div>

      <a-skeleton :loading="loading" active>
        <a-table :columns="columns" :dataSource="items.data" rowKey="id" :pagination="pagination" @change="tableChanged">

          <h5 slot="datetime" slot-scope="datetime" class="text-center">
            {{ moment(datetime).format('DD/MM/YYYY HH:mm:ss') }}
          </h5>

          <h5 slot="mutationType" slot-scope="record">
            <span :style="{ color:  serviceColors[record.transaction.service_type ] }">{{ record.transaction.service_type.toUpperCase() }}</span>/ <span :style="{ color: types[record.mutation_type] }">{{ record.mutation_type.toUpperCase() }}</span>
          </h5>

          <div slot="reference" slot-scope="record">
            <template v-if="transactionServices.includes(record.transaction.service_type)">
              <h5>
                {{ record.transaction.subscriber_id }}
                <br>
               <a-icon type="barcode" /> <code>{{ record.transaction.id }}</code>
              </h5>
            </template>
            <template v-else>
              <h5>
                <a-icon type="barcode" /> <code>{{ record.transaction.id }}</code>
              </h5>
            </template>
          </div>

          <div slot="product" slot-scope="record" class="copyable">
            <template v-if="transactionServices.includes(record.transaction.service_type)">
              <h5>
                <a-icon type="code" /> <code>{{ record.transaction.product.code }}</code>
                <br>
                <a-icon type="qrcode" /> {{ record.transaction.product.name }}
              </h5>
            </template>
            <template v-else>
              <h5><em>Financial Services</em></h5>
            </template>

          </div>

          <h5 slot="amount" slot-scope="amount"><currency :amount="amount" /></h5>

          <h5 slot="balanceBefore" slot-scope="balanceBefore"><currency :amount="balanceBefore" /></h5>

          <h5 slot="balanceAfter" slot-scope="balanceAfter"><currency :amount="balanceAfter" /></h5>

          <h5 slot="loanBalanceBefore" slot-scope="loanBalanceBefore"><currency :amount="loanBalanceBefore" /></h5>

          <h5 slot="loanBalanceAfter" slot-scope="loanBalanceAfter"><currency :amount="loanBalanceAfter" /></h5>

        </a-table>
      </a-skeleton>
    </a-card>

    <a-drawer :width="720" placement="right" :closable="true" :visible="filtering" @close="() => filtering = false">
      <h-mutation-filter :backend="backend" :filters="filters" :excludes="excludes" @filtered="filtered" />
    </a-drawer>
  </div>
</template>
